module.exports = {
      id: "icons:tick-usage",
      viewBox: "0 0 11 8",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:tick-usage",
      toString: function () {
        return this.url;
      }
    }